<template>
  <Loader :value="promise" theme="default" class="task-reference-lead">
    <Contact v-if="item" :value="item.contact" theme="list" :avatar-size="80">
      <template #actions>
        <ButtonComponent
          v-if="showAction && action"
          tag="router-link"
          :to="action"
          :label="$t('gotoItem', [$tc('lead', 1).toLowerCase()])"
          :icon="['fal', 'arrow-to-right']"
          class="task-reference-lead__action mt-1"
        />
      </template>
    </Contact>
  </Loader>
</template>

<script>
import Api from '@/api/Contact'
import Contact from '@/components/Contact/Card'

export default {
  props: {
    value: String,
  },
  watch: {
    value: {
      handler: 'fetch',
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      item: null,
    }
  },
  computed: {
    showAction() {
      return this.action.name !== this.$route.name
    },
    action() {
      const context = (this.$path('reference.onModel', this.item) || 'project').toLowerCase()

      return { name: `${context}-lead-edit`, params: { id: this.value, reference: this.$path('item.reference.id') } }
    },
  },
  methods: {
    fetch() {
      this.promise = Api.get({ id: this.value }, { query: 'TaskReferenceLead' }).then(item => (this.item = item))
    },
  },
  components: {
    Contact,
  },
}
</script>

<style lang="scss">
.task-reference-lead {
  flex-grow: initial;
  padding-right: 2.5rem;

  .contact-card__action {
    display: none;
  }

  &__action {
    font-size: 0.8em !important;
  }
}
</style>
